module.exports = __webpack_public_path__ + "img/plus-regular.8b7ede60.svg";